import React from 'react';
import { Container, Row } from 'reactstrap';
import ShowClinicEvent from './components/ShowClinicEvent';

const ClinicEvent = (props) => {
    return (<Container className="dashboard">
        <Row>
            <ShowClinicEvent data={props.location.state.data} />
        </Row>
    </Container>);
}

export default ClinicEvent;